/**
 * Benefits mega menu — preload media + cache panel height so first open is instant.
 */
(function () {
  const ROOT_VAR = '--n50-benefits-submenu-height';
  const BENEFITS_SUBMENU = '.menu-list__list-item--benefits .menu-list__submenu--n50-mega';
  const BENEFITS_INNER = '.menu-list__list-item--benefits .menu-list__submenu-inner--n50-mega';

  /** @param {ParentNode} root */
  function preloadImages(root) {
    root.querySelectorAll('.n50-benefits-mega img').forEach((img) => {
      if (!(img instanceof HTMLImageElement)) return;
      img.loading = 'eager';
      img.decoding = 'async';
      if (img.complete) return;
      const preload = new Image();
      preload.src = img.currentSrc || img.src;
    });
  }

  function measurePanelHeight() {
    const inner = document.querySelector(BENEFITS_INNER);
    const submenu = document.querySelector(BENEFITS_SUBMENU);
    const header = document.getElementById('header-component');
    if (!inner || !submenu || !header) return 0;

    const submenuEl = /** @type {HTMLElement} */ (submenu);
    const previousVisibility = submenuEl.style.visibility;
    submenuEl.style.visibility = 'visible';

    const height = inner.getBoundingClientRect().height;

    submenuEl.style.visibility = previousVisibility;

    if (height > 0) {
      document.documentElement.style.setProperty(ROOT_VAR, `${Math.ceil(height)}px`);
      header.style.setProperty('--n50-benefits-submenu-height', `${Math.ceil(height)}px`);
    }

    return height;
  }

  function init() {
    const mega = document.querySelector('.n50-benefits-mega');
    if (!mega) return;

    preloadImages(mega);
    measurePanelHeight();

    mega.querySelectorAll('.n50-benefits-mega__photo').forEach((img) => {
      if (!(img instanceof HTMLImageElement)) return;
      if (img.complete) return;
      img.addEventListener('load', () => measurePanelHeight(), { once: true });
    });

    window.addEventListener('resize', () => {
      requestAnimationFrame(measurePanelHeight);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
